<p-dialog
  [modal]="true"
  [header]="header"
  [(visible)]="display"
  appendTo="body"
  [maximizable]="true"
  [breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
  [style]="{ width: '50vw', backgroundColor: '#fff' }"
  (onHide)="closeModal()"
>
  <div *ngIf="type === 'string'">
    {{ content }}
  </div>

  <div *ngIf="type === 'error'">
    <div class="errorHeader" *ngIf="serverError">
      A server error has occurred; additional information may have been logged for troubleshooting.
    </div>

    <div class="errorMessage" *ngIf="serverError">{{ message.message }}</div>

    <div class="errorMessageGeneral" *ngIf="!serverError">{{ message.message }}</div>

    <div class="errorSubHeader" *ngIf="serverError">
      Please contact support with a screenshot of this message along with any steps or information needed that can assist in troubleshooting
      this problem.
    </div>

    <div class="errorDetails">
      Error: {{ timestamp }} / {{ message.type }} / {{ message.errorCode }}<br />
      HTTP {{ message.statusCode }}: {{ message.error.url }}<br />
      Request ID: {{ message.requestId }}<br />
    </div>
  </div>
</p-dialog>
